import { FC } from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@/assets/chevron-right.svg';
import { Button } from '@/components/ui/button';
import { useBreadcrumbs } from '../hooks/use-breadcrumbs';

export const Breadcrumbs: FC = () => {
  const crumbs = useBreadcrumbs();

  if (crumbs.length < 2) {
    return null;
  }

  return (
    <nav aria-label="breadcrumbs">
      <ol className="mt-6 mb-2 flex flex-row gap-4 text-gray-400">
        {crumbs.map(({ display, to, isCurrent }, index) => (
          <li className="flex flex-row items-center gap-4" key={index}>
            {index > 0 && (
              <span aria-hidden="true">
                <ChevronRightIcon />
              </span>
            )}
            <Button
              as={Link}
              className="rounded-md leading-5 hover:text-black"
              to={to}
              variant="unstyled"
              {...(isCurrent ? { 'aria-current': 'location' } : {})}
            >
              {display}
            </Button>
          </li>
        ))}
      </ol>
    </nav>
  );
};
